import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllReceivedOil } from '../../actions/oilActions'
import OilRecordView from '../../containers/Oil/OilRecordEcoCEO/OilRecordEcoCEO'

const OilRecord = () => {
  const dispatch = useDispatch();
  const { allReceivedOil } = useSelector(state => state.oil);
  const { userInfo } = useSelector((state) => state.userInfo);
  const [skipReceivedOil, setSkipReceivedOil] = useState(0);
  const [userEmail, setUserEmail] = useState('')
  const auxAllReceivedOil = [];
  const limitReceivedOil = 15;

  useEffect(() => {
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state === 2) {
        dispatch(getAllReceivedOil(userInfo.franchiseID._id, userEmail, skipReceivedOil, limitReceivedOil));
      }
    }
    return () => { }
  }, [userInfo, skipReceivedOil]);

  useEffect(() => {
    clearReceivedOil();

    return () => {

    }
  }, [userEmail])

  allReceivedOil.forEach((receivedOil) => {
    auxAllReceivedOil.push(
      {
        id: receivedOil._id,
        user: receivedOil.userId.email,
        date: new Date(receivedOil.creationDate).toLocaleDateString(),
        quantity: receivedOil.liters,
        ecopoints: receivedOil.pointsReceived,
      }
    );
  });

  const clearReceivedOil = () => {
    auxAllReceivedOil.length = 0;
    allReceivedOil.length = 0;
    setSkipReceivedOil(0);

    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state === 2) {
        dispatch(getAllReceivedOil(userInfo.franchiseID._id, userEmail, skipReceivedOil, limitReceivedOil));
      }
    }
    else if(userInfo.warehouseID){
      dispatch(getAllReceivedOil(userInfo.warehouseID, userEmail, skipReceivedOil, limitReceivedOil));

    }
  }

  return (
    <OilRecordView
      oilRecords={auxAllReceivedOil}
      limitReceivedOil={limitReceivedOil}
      skipReceivedOil={skipReceivedOil}
      setSkipReceivedOil={setSkipReceivedOil}
      userEmail={userEmail}
      setUserEmail={setUserEmail}
    />
  )
}

export default OilRecord